// extracted by mini-css-extract-plugin
export default {"productsList":"shoppingPage_productsList__TyasC","body":"shoppingPage_body__lqpe8"};